import { brandLoaderSrc } from "@humansignal/core";
import { cn } from "../../utils/bem";
import "./Spinner.prefix.css";

export const Spinner = ({ className, style, size = 32 }) => {
  const rootClass = cn("spinner-ls");

  const sizeWithUnit = typeof size === "number" ? `${size}px` : size;

  return (
    <div
      className={rootClass.mix(className).toClassName()}
      style={{ ...(style ?? {}), "--spinner-size": sizeWithUnit }}
    >
      <img className={rootClass.elem("mark").toClassName()} src={brandLoaderSrc()} alt="" aria-hidden="true" />
    </div>
  );
};
